import React from "react";

/**
 * Forward/Slash diagonal section divider.
 * Consistent angle (~12° from horizontal) and stripe thickness across every
 * placement — pass any number of stripes, the proportions stay even.
 */
export const SlashDivider = ({
  from = "#004DBF",
  stripes = ["#FFAE00", "#F95300", "#00563E"],
  to = "#FBF6E9",
  height = 28,
  fullWidth = false,
  className = "",
}) => {
  // Each stripe occupies a fixed horizontal slab; the slab edges are sheared
  // by `SHEAR` units to give the diagonal. `SHEAR` controls the angle.
  const SHEAR = 22; // % — bigger = steeper diagonal
  // When fullWidth, the stripe band spans 0% → 100% (with shear absorbed at the edges)
  // so the diagonal goes edge-to-edge across the section.
  const bandStart = fullWidth ? 0 : SHEAR;
  const bandEnd = fullWidth ? 100 : 100 - SHEAR + 8; // ~92% otherwise
  const stripeWidth = (bandEnd - bandStart) / stripes.length;

  return (
    <div
      className={`relative w-full overflow-hidden ${className}`}
      style={{ height, background: from }}
      aria-hidden="true"
      data-testid="slash-divider"
    >
      {/* "to" wash on the right of the diagonal */}
      <div
        className="absolute inset-0"
        style={{
          background: to,
          clipPath: `polygon(${100 - SHEAR}% 0, 100% 0, 100% 100%, ${100}% 100%, ${SHEAR}% 100%, ${SHEAR + (100 - 2 * SHEAR)}% 0)`,
        }}
      />
      {stripes.map((c, i) => {
        const left = bandStart + i * stripeWidth;
        const right = left + stripeWidth;
        return (
          <div
            key={i}
            className="absolute inset-0"
            style={{
              background: c,
              clipPath: `polygon(${left}% 0, ${right}% 0, ${right - SHEAR}% 100%, ${left - SHEAR}% 100%)`,
            }}
          />
        );
      })}
    </div>
  );
};

export default SlashDivider;
